import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Stack, Text } from '@adc/parallax-component-library';
import { useApiError } from 'Hooks';
import { MainContainer, ThemedImage } from 'Components/utility';
import i18n from 'Utilities/i18n';
import { verifyEmail } from 'Services/auth';
const mapStateToProps = ({ env: { osType, osVersion, app, appVersion }, nav: { query: { token }, }, }) => {
    return {
        osType,
        osVersion,
        app,
        appVersion,
        token,
    };
};
const connector = connect(mapStateToProps);
const VerifyEmail = ({ osType, osVersion, app, appVersion, token }) => {
    const isLLU = app === 'llu5';
    const { showApiErrorModal } = useApiError();
    const resourceKey = isLLU
        ? 'Global.microcopy.common.libreLinkUpLogoLight'
        : 'Global.microcopy.common.libreViewLogoLight';
    useEffect(() => {
        (async () => {
            if (!token) {
                return;
            }
            try {
                await verifyEmail(token, osType, osVersion, app, appVersion);
            }
            catch (err) {
                showApiErrorModal();
            }
        })();
    }, [app, appVersion, osType, osVersion, showApiErrorModal, token]);
    return (React.createElement(MainContainer, null,
        React.createElement(Stack, { padding: '$4', marginTop: "$5" },
            React.createElement(ThemedImage, { resourceKey: resourceKey, alt: "", id: resourceKey, style: {
                    height: '40px',
                    objectFit: 'contain',
                } }),
            React.createElement(Stack, { marginTop: "$12" },
                React.createElement("img", { src: i18n.t('EmailConfirmed.content.emailConfirmedImg.media.emailConfirmed'), alt: "", style: {
                        objectFit: 'contain',
                        height: 80,
                    }, id: "EmailConfirmed.checkEmail.media" })),
            React.createElement(Stack, { gap: "$3", marginTop: "$7" },
                React.createElement(Text, { color: "$text.100", type: "$h2.strong", textAlign: "center", testID: "EmailConfirmed.title" }, i18n.t('EmailConfirmed.title')),
                React.createElement(Text, { color: "$text.100", type: "$bodyBase.default", textAlign: "center", testID: "EmailConfirmed.subtitle" }, i18n.t('EmailConfirmed.subtitle'))))));
};
export default connector(VerifyEmail);
